import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { Badge } from 'dibs-elements/exports/Badge.tsx';

import dibsCss from 'dibs-css';

import { type StorefrontOnly_item$data } from './__generated__/StorefrontOnly_item.graphql.ts';

type Props = {
    item: StorefrontOnly_item$data;
    reduceMargins?: boolean;
};

const StorefrontOnlyBadge: FC<Props> = ({ item, reduceMargins }) => {
    if (!item?.isStorefrontOnly) {
        return null;
    }

    return (
        <div className={reduceMargins ? dibsCss.mb2px : dibsCss.mbXsmall} data-tn="storefront-only">
            <Badge type="pill" size="small-heavy">
                <FormattedMessage
                    id="dc.searchProductTile.storefrontOnly"
                    defaultMessage="Storefront Only"
                />
            </Badge>
        </div>
    );
};

export default createFragmentContainer(StorefrontOnlyBadge, {
    item: graphql`
        fragment StorefrontOnly_item on Item {
            isStorefrontOnly
        }
    `,
});
